import { render, staticRenderFns } from "./JuizInput.vue?vue&type=template&id=f257a7e2&"
import script from "./JuizInput.vue?vue&type=script&lang=js&"
export * from "./JuizInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports